import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuType, OrderStatus } from '../constants/KRollConstants';
import { HelperService } from './helper.service';
import { ParseArrayToQueryParamsNumber } from '../constants/CommonFunctions';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  selectedLocation = new FormControl(0, { updateOn: 'blur', validators: Validators.compose([Validators.required]) });
  saleOrderForm: FormGroup;
  processedOrderForm: FormGroup;
  addDeliveryPartner = new FormControl(null);
  addLocalActivityReason = new FormControl(null);
  constructor(
    public helperService: HelperService,
    public httpClient: HttpClient,
    public fb: FormBuilder,
    private router: Router) {

      this.saleOrderForm= this.fb.group({
        type: new FormControl(OrderStatus.All),
        isChecked: new FormControl(true),
        isChildChecked: new FormControl(true),
        salesOrderStatus: this.fb.array([]),
      });
      this.processedOrderForm = this.fb.group({
        type: new FormControl(OrderStatus.All),
        isChecked: new FormControl(true),
        isChildChecked: new FormControl(true),
        processedOrderStatus: this.fb.array([]),
      });

  }
  setSelectedLocationVal(val: number) {
    this.selectedLocation.setValue(val);
  }
  //#region SaleOrderStatusForm
  setSalesOrderStatusToForm(arr: any) {
    const urlParams = new URLSearchParams(window.location.search);
    let order_status = urlParams.get('order_status') ? ParseArrayToQueryParamsNumber(urlParams.get('order_status')) : [];
    order_status = (order_status.length > 0 && arr.map((m: any) => m.id).includes(order_status)) ? order_status : []
    this.saleOrderForm.controls.salesOrderStatus.setValue([]);
    let control = <FormArray>this.saleOrderForm.controls.salesOrderStatus;
    const unselectedByDefault = ['Cancelled', 'Refund Awaiting Approval', 'Refunded'];
    arr.forEach((x: any) => {
      const defaultChecked = (order_status.length > 0)
        ? order_status.includes(x.id)
        : !unselectedByDefault.includes(x.type);
      control.push(this.fb.group({
        id: new FormControl(x.id),
        isChecked: new FormControl(defaultChecked),
        menu: new FormControl(x.menu),
        sale_orders_count: new FormControl(x.sale_orders_count),
        status: new FormControl(x.status),
        type: new FormControl(x.type),
        parent_id: new FormControl(x.parent_id),
      }));
    });
  }

  get getSalesOrderFormStatusArr() {
    return this.saleOrderForm.controls['salesOrderStatus'] as FormArray;
  }
  get isAllOrderStatusSelected() {
    let { salesOrderStatus } = this.saleOrderForm.value;
    return salesOrderStatus != null && salesOrderStatus.every((t: any) => t.isChecked);
  }

  someOrderStatusSelected(): boolean {
    let { salesOrderStatus } = this.saleOrderForm.value;
    if (salesOrderStatus == null) {
      return false;
    }
    // let statusList = salesOrderStatus;
    // statusList.forEach((element: any) => {
    //     if(element){
    //       salesOrderStatus.filter((f: any) => f.parent_id == element.id).map((m: any) => {
    //         if (element.isChecked){
    //           m.isChecked = true
    //           this.saleOrderForm.controls['isChecked'].setValue(true);
    //         }
    //         else{
    //           m.isChecked = false
    //           this.saleOrderForm.controls['isChecked'].setValue(false);
    //         }

    //       });}
    //   });

    // let control = <FormArray>this.saleOrderForm.controls.salesOrderStatus;
    //this.saleOrderForm.patchValue(salesOrderStatus);
    let someComplete = salesOrderStatus.filter((t: any) => t.isChecked).length > 0 && !this.isAllOrderStatusSelected;
    return someComplete;
  }
  setAllOrderStatusSelected(isChecked: boolean) {
    let { salesOrderStatus } = this.saleOrderForm.value;
    if (salesOrderStatus == null) {
      return;
    }
    salesOrderStatus.forEach((t: any) => (t.isChecked = isChecked));
    let control = <FormArray>this.saleOrderForm.controls.salesOrderStatus;
    control.patchValue(salesOrderStatus);
  }

  get allSalesOrdersLength() {
    let { salesOrderStatus } = this.saleOrderForm.value;
    return salesOrderStatus.reduce((acc: number, val: any) => acc + val.sale_orders_count, 0);
  }
  get selectedOrderStatusIds() {
    let { salesOrderStatus } = this.saleOrderForm.value;
    return salesOrderStatus.filter((f: any) => f.isChecked).map((m: any) => m.id);
  }
  //#endregion

  //#region ProcessedOrderStatusForm
  setProcessedOrderStatusToForm(arr: any) {
    const urlParams = new URLSearchParams(window.location.search);
    let order_status = urlParams.get('order_status') ? ParseArrayToQueryParamsNumber(urlParams.get('order_status')) : [];
    order_status = (order_status.length > 0 && arr.map((m: any) => m.id).includes(order_status)) ? order_status : []
    let control = <FormArray>this.processedOrderForm.controls.processedOrderStatus;
    const unselectedByDefault = ['Cancelled', 'Refund Awaiting Approval', 'Refunded'];
    arr.forEach((x: any) => {
      const defaultChecked = (order_status.length > 0)
        ? order_status.includes(x.id)
        : !unselectedByDefault.includes(x.type);
      control.push(this.fb.group({
        id: new FormControl(x.id),
        isChecked: new FormControl(defaultChecked),
        menu: new FormControl(x.menu),
        sale_orders_count: new FormControl(x.sale_orders_count),
        status: new FormControl(x.status),
        type: new FormControl(x.type),
        parent_id: new FormControl(x.parent_id),
      }));
    });
  }

  get getProcessedOrderFormStatusArr() {
    return this.processedOrderForm.controls['processedOrderStatus'] as FormArray;
  }
  get isAllProcessedOrderStatusSelected() {
    let { processedOrderStatus } = this.processedOrderForm.value;
    return processedOrderStatus != null && processedOrderStatus.every((t: any) => t.isChecked);
  }
  someProcessedOrderStatusSelected(): boolean {
    let { processedOrderStatus } = this.processedOrderForm.value;
    if (processedOrderStatus == null) {
      return false;
    }
    let someComplete = processedOrderStatus.filter((t: any) => t.isChecked).length > 0 && !this.isAllProcessedOrderStatusSelected;
    return someComplete;
  }
  setAllProcessedOrderStatusSelected(isChecked: boolean) {
    let { processedOrderStatus } = this.processedOrderForm.value;
    if (processedOrderStatus == null) {
      return;
    }
    processedOrderStatus.forEach((t: any) => (t.isChecked = isChecked));
    let control = <FormArray>this.processedOrderForm.controls.processedOrderStatus;
    control.patchValue(processedOrderStatus);
  }
  get allProcessedOrdersLength() {
    let { processedOrderStatus } = this.processedOrderForm.value;
    return processedOrderStatus.reduce((acc: number, val: any) => acc + val.sale_orders_count, 0);
  }
  get selectedProcessedOrderStatusIds() {
    let { processedOrderStatus } = this.processedOrderForm.value;
    return processedOrderStatus.filter((f: any) => f.isChecked).map((m: any) => m.id);
  }
  //#endregion

  dashboardRedirectionToSalesOrder(arr: any, id?: any, isArray?: any) {
    const formArray = this.saleOrderForm.get('salesOrderStatus') as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    arr = arr.salesOrderStatus.filter((f: any) => f.menu == MenuType.Sale)
    let control = <FormArray>this.saleOrderForm.controls.salesOrderStatus;
    const unselectedByDefault = ['Cancelled', 'Refund Awaiting Approval', 'Refunded'];
    arr.forEach((x: any) => {
      const defaultChecked = isArray ? !unselectedByDefault.includes(x.type) : (x.id == id ? true : false);
      control.push(this.fb.group({
        id: new FormControl(x.id),
        isChecked: new FormControl(defaultChecked),
        menu: new FormControl(x.menu),
        sale_orders_count: new FormControl(x.sale_orders_count),
        status: new FormControl(x.status),
        type: new FormControl(x.type),
        parent_id: new FormControl(x.parent_id),
      }));
    });
  }

  dashboardRedirectionToProcessOrder(arr: any, id?: any, isArray?: any) {
    const formArray = this.processedOrderForm.get('processedOrderStatus') as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    arr = arr.processedOrderStatus.filter((f: any) => f.menu == MenuType.Processed)
    let control = <FormArray>this.processedOrderForm.controls.processedOrderStatus;
    const unselectedByDefault = ['Cancelled', 'Refund Awaiting Approval', 'Refunded'];
    arr.forEach((x: any) => {
      const defaultChecked = isArray ? !unselectedByDefault.includes(x.type) : (x.id == id ? true : false);
      control.push(this.fb.group({
        id: new FormControl(x.id),
        isChecked: new FormControl(defaultChecked),
        menu: new FormControl(x.menu),
        sale_orders_count: new FormControl(x.sale_orders_count),
        status: new FormControl(x.status),
        type: new FormControl(x.type),
        parent_id: new FormControl(x.parent_id),
      }));
    });
  }

}
